import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core'

const useStyles = makeStyles((theme) => {
   
    return{
        transactionName:{
            marginBottom: 40,
            color: "#5D70A4"
        },
        
    }
  });
const Transactions = () =>{
    const classes = useStyles()
    return(
        <Typography 
        variant="subtitle1" 
        className={classes.transactionName}
        >
            Transactions
        </Typography>
    )
}

export default Transactions;